import {createStrokeSVG} from './TEMPLATE'

// tabler: code
export const CodeBrackets_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M7 8l-4 4l4 4', 'M17 8l4 4l-4 4', 'M14 4l-4 16'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: code
export const CodeBrackets_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: ['M7 8l-4 4l4 4', 'M17 8l4 4l-4 4', 'M14 4l-4 16'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
